import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/discount",
    icon: "android-menu",
    name: "discount",
    title: "折扣管理",
    component: Main,
    children: [
      {
        path: "daily",
        title: "日常折扣",
        name: "DiscountDaily",
        component: (resolve) => {
          require(["@/views/discount/daily/index.vue"], resolve);
        },
      },
      {
        path: "daily/vendor",
        title: "日常折扣",
        name: "DiscountDailyVendor",
        meta: {
          name: "daily-discount",
        },
        component: (resolve) => {
          require(["@/views/discount/daily/vendor/index.vue"], resolve);
        },
      },
      {
        path: "detail/daily",
        title: "折扣查看",
        name: "discount-check-daily",
        meta: {
          name: "daily-discount",
        },
        parent: [
          {
            path: "",
            name: "discount",
            title: "折扣管理",
          },
          {
            path: "/discount/daily",
            title: "日常折扣",
            name: "DiscountDaily",
          },
        ],
        component: (resolve) => {
          require(["@/views/discount/detail/index.vue"], resolve);
        },
      },
      {
        path: "promotion",
        title: "活动折扣",
        name: "DiscountPromotion",
        component: (resolve) => {
          require(["@/views/discount/promotion/index.vue"], resolve);
        },
      },
      {
        path: "promotion/list/:id",
        title: "买手店折扣活动",
        name: "DiscountPromotion",
        component: (resolve) => {
          require(["@/views/discount/promotion/list.vue"], resolve);
        },
      },
      {
        path: "promotion/manage/:vendorId/:id",
        title: "买手店活动折扣管理",
        name: "DiscountPromotionVendorManage",
        component: (resolve) => {
          require(["@/views/discount/promotion/manage.vue"], resolve);
        },
      },
      {
        path: "detail/promotion",
        title: "折扣查看",
        name: "discount-check-promotion",
        meta: {
          name: "daily-discount",
        },
        parent: [
          {
            path: "",
            name: "discount",
            title: "折扣管理",
          },
          {
            path: "/discount/promotion",
            title: "活动折扣",
            name: "DiscountPromotion",
          },
        ],
        component: (resolve) => {
          require(["@/views/discount/detail/promotion.vue"], resolve);
        },
      },
      {
        path: "/discount/promotion/sku",
        title: "特殊SKU折扣设置",
        name: "promotion-sku",
        parent: [
          {
            path: "",
            title: "折扣管理",
          },
          {
            path: "",
            title: "活动折扣",
          },
        ],
        component: (resolve) => {
          require(["@/views/discount/promotion/sku.vue"], resolve);
        },
      },
      {
        path: "/discount/daily/sku",
        title: "特殊SKU折扣设置",
        name: "daily-sku",
        parent: [
          {
            path: "",
            title: "折扣管理",
          },
          {
            path: "",
            title: "日常折扣",
          },
        ],
        component: (resolve) => {
          require(["@/views/discount/daily/vendor/sku.vue"], resolve);
        },
      },
      {
        path: "supplyPriceRule",
        title: "供货价店铺额外价格",
        name: "supplyPriceRule",
        component: (resolve) => {
          require(["@/views/discount/supplyPriceRule/index.vue"], resolve);
        },
      },
      {
        path: "supplyPriceProduct",
        title: "供货价店铺商品列表",
        name: "supplyPriceProduct",
        component: (resolve) => {
          require(["@/views/discount/supplyPriceProduct/index.vue"], resolve);
        },
      },

      // ── CN 路由 ──
      {
        path: "cn/daily",
        title: "日常折扣(CN)",
        name: "DiscountDailyCn",
        component: (resolve) => {
          require(["@/views/discount/cn/daily/index.vue"], resolve);
        },
      },
      {
        path: "cn/daily/vendor",
        title: "日常折扣(CN)",
        name: "DiscountDailyVendorCn",
        meta: { name: "daily-discount" },
        component: (resolve) => {
          require(["@/views/discount/cn/daily/vendor/index.vue"], resolve);
        },
      },
      {
        path: "/discount/cn/daily/sku",
        title: "特殊SKU折扣设置(CN)",
        name: "daily-sku-cn",
        parent: [{ path: "", title: "折扣管理" }, { path: "", title: "日常折扣" }],
        component: (resolve) => {
          require(["@/views/discount/cn/daily/vendor/sku.vue"], resolve);
        },
      },
      {
        path: "cn/detail/daily",
        title: "折扣查看(CN)",
        name: "discount-check-daily-cn",
        meta: { name: "daily-discount" },
        parent: [
          { path: "", name: "discount", title: "折扣管理" },
          { path: "/discount/cn/daily", title: "日常折扣", name: "DiscountDailyCn" },
        ],
        component: (resolve) => {
          require(["@/views/discount/cn/detail/index.vue"], resolve);
        },
      },
      {
        path: "cn/supplyPriceRule",
        title: "供货价店铺额外价格(CN)",
        name: "supplyPriceRuleCn",
        component: (resolve) => {
          require(["@/views/discount/cn/supplyPriceRule/index.vue"], resolve);
        },
      },
      {
        path: "cn/supplyPriceProduct",
        title: "供货价店铺商品列表(CN)",
        name: "supplyPriceProductCn",
        component: (resolve) => {
          require(["@/views/discount/cn/supplyPriceProduct/index.vue"], resolve);
        },
      },
    ],
  },
];

export default customerRoutes
